<template>
    <b-card
        no-body
    >
        <div class="card-header">
            <div
                class="card-group-title"
            >
                <h4>
                    Monthly usage
                </h4>
            </div>
        </div>
        <div
            v-if="chartData.length"
            ref="REF_USAGE_LATEST_MONTH"
        >
            <VsSvgBar
                :data="chartData"
                xKey="month"
                :yKeys="['usage']"
                :barColors="barColors"
                :barPaddingRate="0.2"
                :multiOffset="false"
                :width="width"
                :height="height"
                :xAxis="true"
                :yAxis="true"
                :labelRotate="0"
                :tickSize="0.7"
                :tickPadding="15"
                :yGrid="5"
                :rounding="0"
                :minBarHeight="0"
                :labelColor="themeColors.currentColor"
                barLabel
                xLabel
                yLabel
                @click:point="clickPointHandler"
            >
                <template v-slot:bar-label="{ item }">
                    <template v-if="item.title > 0">
                        {{ item.title }}
                    </template>
                </template>
                <template v-slot:x-axis="{ item }">
                    <template v-if="item.index % 2 === 0">
                        {{ item.label }}
                    </template>
                </template>
                <template v-slot:y-axis="{ item }">
                    {{ item.label }}
                </template>
            </VsSvgBar>
        </div>
        <b-card-body v-else
            class="text-center"
        >
            {{ $t("org.message.No Data") }}
        </b-card-body>
    </b-card>
</template>

<script>
import { ref, toRefs, computed, getCurrentInstance, onUpdated, onMounted, onUnmounted } from '@vue/composition-api'
import { VsSvgBar } from '@/libs/vuesign/chart'
export default {
    components: {
        VsSvgBar
    },
    props: {
        themeColors: {
            type: Object,
            default: function () {
                return {}
            }
        },
        chartData: {
            type: Array,
            default: function () {
                return []
            }
        }
    },
    setup (props, context) {
        const vm = getCurrentInstance().proxy
        const { themeColors, chartData } = toRefs(props)
        const height = 175
        const width = ref(0)
        const barColors = computed(() => {
            return {
                usage: themeColors.value.primary
            }
        })
        const REF_USAGE_LATEST_MONTH = ref(null)
        const resize = () => {
            if (REF_USAGE_LATEST_MONTH.value) {
                width.value = REF_USAGE_LATEST_MONTH.value.getBoundingClientRect().width
            }
        }

        // click
        const clickPointHandler = (event) => {
            const month = chartData.value[event.data.index].month
            context.emit('api:fetchDailyUsage', { month })
        }

        onUpdated(resize)
        onMounted(() => {
            vm.$nextTick(() => {
                resize()
                window.addEventListener('resize', resize)
            })
        })
        onUnmounted(() => {
            window.removeEventListener('resize', resize)
        })
        return {
            REF_USAGE_LATEST_MONTH,
            barColors,
            width,
            height,
            clickPointHandler
        }
    }
}
</script>

<style>

</style>
